import React from 'react';
import PropTypes from 'prop-types';
import { Sum, C, retrievePrecisionNumber } from 'shared/helpers';

import Styles from './Row.module.scss';
import { useIntl } from 'react-intl';

const retrieveTotalPrecision = (key) => {
  switch (key) {
    case 'C':
      return 0;
    default:
      return 2;
  }
};

export default function Row({
  renderables,
  produtos,
  difference,
  lighter,
  tableKey,
}) {
  const { formatNumber } = useIntl();
  const { Row, Block, Lighter } = Styles;

  let divCount = 0;

  const Produtos = [];
  const Difference = [];
  const TotalStore = {
    N: 0,
    P2O5: 0,
    K2O: 0,
    Q: 0,
    C: 0,
  };
  const DiffStore = {
    N: 0,
    P2O5: 0,
    K2O: 0,
    Q: 0,
    C: 0,
  };

  const TotalsMap = [
    { key: 'N', divide: 'N' },
    { key: 'P2O5', divide: 'N' },
    { key: 'K2O', divide: 'N' },
    { key: 'Q', suffix: ' kg/ha', style: { width: '100px' } },
    {
      key: 'C',
      prefix: 'R$ ',
      suffix: ' /ha',
      style: { width: '100px' },
    },
  ];

  let Totals = false;
  let Diff = false;

  if (produtos[0] instanceof Array) {
    Totals = true;
    for (let i = 0; i < produtos.length; i++) {
      const res = [];
      const resa = {};
      produtos[i].map((prod) => {
        TotalStore.N += (Number(prod.N) / 100) * prod.quantidade;
        TotalStore.P2O5 += (Number(prod.P2O5) / 100) * prod.quantidade;
        TotalStore.K2O += (Number(prod.K2O) / 100) * prod.quantidade;
        TotalStore.C += Number((prod.valor / 1000) * prod.quantidade);
        TotalStore.Q += Number(prod.quantidade);
        return true;
      });
      for (let k = 0; k < renderables.length; k++) {
        resa[renderables[k]] = Sum(
          produtos[i].map(
            (prod) => (prod[renderables[k]] / 100) * prod.quantidade,
          ),
        );
      }
      res.push(resa);
      Produtos.push(...res);
    }
  }

  if (difference instanceof Array) {
    Diff = true;
    for (let i = 0; i < difference.length; i++) {
      const res = [];
      const resa = {};
      difference[i].map((prod) => {
        DiffStore.N += (Number(prod.N) / 100) * prod.quantidade;
        DiffStore.P2O5 += (Number(prod.P2O5) / 100) * prod.quantidade;
        DiffStore.K2O += (Number(prod.K2O) / 100) * prod.quantidade;
        DiffStore.C += Number((prod.valor / 1000) * prod.quantidade);
        DiffStore.Q += Number(prod.quantidade);
        return true;
      });
      for (let k = 0; k < renderables.length; k++) {
        resa[renderables[k]] = Sum(
          difference[i].map(
            (prod) => (prod[renderables[k]] / 100) * prod.quantidade,
          ),
        );
      }
      res.push(resa);
      Difference.push(...res);
    }
  }

  const staticNonTotal = (r) => (
    <div
      key={`${tableKey}_div${++divCount}`}
      className={C(Block, [lighter, Lighter])}
    >
      {formatNumber(
        Sum(
          produtos.map(
            (x) =>
              (Number((String(x[r]) || '0').replace(',', '.')) / 100) *
              x.quantidade,
          ),
        ),
        {
          minimumFractionDigits: retrievePrecisionNumber(r, 'comparativo'),
          maximumFractionDigits: retrievePrecisionNumber(r, 'comparativo'),
        },
      )}
    </div>
  );

  const staticTotal = (key) => {
    const result =
      Sum(
        produtos.map(
          (x) =>
            (Number((String(x[key]) || '0').replace(',', '.')) / 100) *
            x.quantidade,
        ),
      ) /
        Sum(
          produtos.map(
            (x) =>
              (Number((String(x.N) || '0').replace(',', '.')) / 100) *
              x.quantidade,
          ),
        ) || 0;

    return (
      <div
        key={`${tableKey}${++divCount}`}
        className={C(Block, [lighter, Lighter])}
      >
        {formatNumber(result === Infinity ? 0 : result, {
          minimumFractionDigits: retrievePrecisionNumber(key, 'comparativo'),
          maximumFractionDigits: retrievePrecisionNumber(key, 'comparativo'),
        })}
      </div>
    );
  };

  // eslint-disable-next-line react/prop-types
  const nutrientsDynamicTotal = ({
    key,
    prefix,
    suffix,
    func,
    style,
    divide,
  }) => {
    prefix = prefix || '';
    suffix = suffix || '';
    func = func || ((x) => x);
    style = style || {};
    const divisorTotal = divide ? TotalStore[divide] : 1;
    const result = func(
      TotalStore[key] / (!divisorTotal ? 1 : divisorTotal) || 0,
    );
    return (
      <div
        key={`${tableKey}${++divCount}`}
        className={C(Block, [lighter, Lighter])}
        style={{ ...(style || {}) }}
      >
        {prefix +
          formatNumber(result === Infinity ? 0 : result, {
            minimumFractionDigits: retrieveTotalPrecision(key),
            maximumFractionDigits: retrieveTotalPrecision(key),
          }) +
          suffix}
      </div>
    );
  };

  const diffNutrientsStaticTotal = (r) => (
    <div
      key={`${tableKey}_div${++divCount}`}
      className={C(Block, [lighter, Lighter])}
    >
      {formatNumber(
        Sum(
          Produtos.map((x, y) => Number(Difference[y][r] || 0) - Number(x[r])),
        ),
        {
          minimumFractionDigits: retrievePrecisionNumber(r, 'comparativo'),
          maximumFractionDigits: retrievePrecisionNumber(r, 'comparativo'),
        },
      )}
    </div>
  );

  const nutrientsStaticTotal = (r) => (
    <div
      key={`${tableKey}_div${++divCount}`}
      className={C(Block, [lighter, Lighter])}
    >
      {formatNumber(Sum(Produtos.map((x) => Number(x[r]))), {
        minimumFractionDigits: retrievePrecisionNumber(r, 'comparativo'),
        maximumFractionDigits: retrievePrecisionNumber(r, 'comparativo'),
      })}
    </div>
  );

  // eslint-disable-next-line react/prop-types
  const diffNutrientsDynamicTotal = ({
    key,
    divide,
    prefix,
    suffix,
    func,
    style,
  }) => {
    prefix = prefix || '';
    suffix = suffix || '';
    func = func || ((x) => x);
    style = style || {};
    const divisorDiff = divide ? DiffStore[divide] : 0;
    const divisorTotal = divide ? TotalStore[divide] : 0;
    const result = func(
      DiffStore[key] / (!divisorDiff ? 1 : divisorDiff) -
        TotalStore[key] / (!divisorTotal ? 1 : divisorTotal) || 0,
    );

    return (
      <div
        key={`${tableKey}${++divCount}`}
        className={C(Block, [lighter, Lighter])}
        style={{ ...style }}
      >
        {prefix +
          formatNumber(result === Infinity ? 0 : result, {
            minimumFractionDigits: retrieveTotalPrecision(key),
            maximumFractionDigits: retrieveTotalPrecision(key),
          }) +
          suffix}
      </div>
    );
  };

  return !Totals ? (
    <div className={Row}>
      {renderables.map((r) => staticNonTotal(r))}
      {['N', 'P2O5', 'K2O'].map((key) => staticTotal(key))}
      <div className={C(Block, [lighter, Lighter])} style={{ width: '100px' }}>
        {`${formatNumber(
          Sum(produtos.map((produto) => Number(produto.quantidade))),
          { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        )} kg/ha`}
      </div>
      <div className={C(Block, [lighter, Lighter])} style={{ width: '100px' }}>
        {`R$ ${formatNumber(
          Sum(
            produtos.map(
              (produto) =>
                Number(produto.valor / 1000) * Number(produto.quantidade),
            ),
          ),
          { minimumFractionDigits: 0, maximumFractionDigits: 0 },
        )} /ha`}
      </div>
    </div>
  ) : !Diff ? (
    <div className={Row}>
      {renderables.map((r) => nutrientsStaticTotal(r))}
      {TotalsMap.map((x) => nutrientsDynamicTotal(x))}
    </div>
  ) : (
    <div className={Row}>
      {renderables.map((r) => diffNutrientsStaticTotal(r))}
      {TotalsMap.map((x) => diffNutrientsDynamicTotal(x))}
    </div>
  );
}

Row.defaultProps = {
  lighter: false,
  difference: null,
};

Row.propTypes = {
  renderables: PropTypes.array.isRequired,
  lighter: PropTypes.bool,
  produtos: PropTypes.array.isRequired,
  difference: PropTypes.any,
  tableKey: PropTypes.string.isRequired,
};
